import * as React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import TextInput from '../TextInput/TextInput';
import {Field, MANDAT, PHONE_NUMBERS_MASKS, checkInvalidPhone} from '../../../utils/utils';
import SelectWithLabel from '../SelectWithLabel/SelectWithLabel';
import ServiceSelector from '../ServiceSelector/ServiceSelector';
import ConsentSelector from '../ConsentSelector/ConsentSelector';

interface Props {
  value: any;
  field: Field;
  onChange: (value: any) => void;
  onEnterKey?: () => void;
  error?: boolean;
  hasFailed?: boolean;
  mandatory?: boolean;
}

interface State {
  value: string;
  formatInvalide: Boolean;
}

export default class FieldBuilder extends React.PureComponent<Props, State> {
  state: State = {value: '', formatInvalide: false};

  componentDidMount = () => {};

  renderTextInput = (field: Field): React.ReactNode => {
    const hasFailed = this.props.hasFailed && field.mandatory && this.props.value === '';
    return (
      <TextInput
        onChange={this.props.onChange}
        onEnterKey={this.props.onEnterKey}
        type='text'
        id={field.key || ''}
        label={field.label}
        value={this.props.value}
        error={this.props.error || hasFailed}
        mandatory={field.mandatory}
        maxLength={field.maxLength}
      />
    );
  };

  renderSelect = (field: Field): React.ReactNode => {
    const hasFailed = this.props.hasFailed && field.mandatory && this.props.value == null;
    return (
      <SelectWithLabel
        className={'select' + (field.mandatory ? ' mandatory-select' : '')}
        classNamePrefix='select'
        value={this.props.value}
        onChange={this.props.onChange}
        options={field.values}
        placeholder={field.label}
        error={this.props.error || hasFailed}
        id={field.key || ''}
      />
    );
  };

  renderServiceSelector = (field: Field): React.ReactNode => {
    return (
      <ServiceSelector
        enableFonction={field.props ? field.props[0] : false}
        value={this.props.value}
        onChange={this.props.onChange}
        error={this.props.error}
        mandatory={field.mandatory}
      />
    );
  };

  renderPhoneInput = (field: Field): React.ReactNode => {
    var value = this.props.value ? this.props.value : '';
    const hasFailed =
      this.props.error && field.mandatory && [null, undefined, ''].includes(this.props.value);

    return (
      <>
        <div className='phone-input-label'>
          {field.label}
          {field.mandatory ? <em className='text-red'> *</em> : ''}
        </div>
        <ReactPhoneInput
          containerClass={
            'react-tel-input' + (hasFailed || this.state.formatInvalide ? ' error' : '')
          }
          country={'fr'}
          preferredCountries={['fr', 'gf', 'gp', 'mq', 're', 'ch', 'be', 'mc']}
          countryCodeEditable={false}
          onChange={(value, data, event, formattedValue) => {
            let workedValue = formattedValue;
            // auto add (0)
            if (value.length === 3 && value.startsWith('33') && value !== '330') {
              workedValue = '+33 (0) ' + value.slice(-1);
            }
            this.props.onChange(workedValue.replace(/\s/g, ''));
          }}
          onBlur={() => this.setState({formatInvalide: checkInvalidPhone(this.props.value)})}
          value={value}
          masks={PHONE_NUMBERS_MASKS}
        />
        <div>
          <em className='phoneHelper'>ex: +33 (0) 4 50 64 08 08</em>
        </div>
        {this.state.formatInvalide && (
          <div className='text-center error-message text-red'>Format invalide</div>
        )}
      </>
    );
  };

  renderMandat = (field: Field): React.ReactNode => {
    return (
      <SelectWithLabel
        className='select mandatory-select'
        classNamePrefix='select'
        value={this.props.value === '' ? null : this.props.value}
        mandatory={this.props.mandatory ?? true}
        onChange={this.props.onChange}
        options={MANDAT}
        placeholder={field.label}
        zIndex={10}
        error={this.props.error}
        id={field.key || ''}
      />
    );
  };

  renderConsent = (field: Field): React.ReactNode => {
    return <ConsentSelector value={this.props.value} onChange={this.props.onChange} />;
  };

  render() {
    const {field} = this.props;

    if (!field) {
      return null;
    }
    if (field.type === 'text') {
      return this.renderTextInput(field);
    }
    if (field.type === 'select') {
      return this.renderSelect(field);
    }
    if (field.type === 'service') {
      return this.renderServiceSelector(field);
    }
    if (field.type === 'consent') {
      return this.renderConsent(field);
    }
    if (field.type === 'phone') {
      return this.renderPhoneInput(field);
    }
    if (field.type === 'mandat') {
      return this.renderMandat(field);
    }

    return null;
  }
}
